// Email-only OTP service powered by Brevo.

// ─── Generate + send OTP ──────────────────────────────────────────────────────
export async function sendEmailOTP({ email, name = "Student" }) {
  if (!email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
    throw new Error("Invalid email address.");
  }

  // Generate a 6-digit OTP on the client
  const code = String(Math.floor(100000 + Math.random() * 900000));

  // Store in sessionStorage with 10-min expiry
  sessionStorage.setItem("shortly-life_email_otp", JSON.stringify({
    code,
    email,
    expires: Date.now() + 10 * 60 * 1000,
  }));

  // Send via Netlify function → Brevo
  const res = await fetch("/.netlify/functions/send-email-otp", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, name, otp: code }),
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || "Failed to send OTP email.");
  }

  return { success: true };
}

// ─── Verify OTP ───────────────────────────────────────────────────────────────
export async function verifyEmailOTP({ email, otp }) {
  const raw = sessionStorage.getItem("shortly-life_email_otp");
  if (!raw) throw new Error("OTP expired. Please request a new one.");

  const stored = JSON.parse(raw);

  if (Date.now() > stored.expires) {
    sessionStorage.removeItem("shortly-life_email_otp");
    throw new Error("OTP expired. Please request a new one.");
  }
  if (stored.email !== email) {
    throw new Error("Email mismatch. Please retry.");
  }
  if (stored.code !== otp) {
    throw new Error("Incorrect OTP. Please try again.");
  }

  sessionStorage.removeItem("shortly-life_email_otp");
  return { success: true };
}
